import {
  ComponentGraphSelectionChanged,
  ComponentTreeSelectionChanged,
  ComponentTreeSelectionStartSelected,
  SelectionStartSet,
  SelectionToggle,
} from './componentSelectionActions';
import { ComponentSelection } from './componentSelectionTypes';

//

// Only relevant for the tree selection, graph selection doesn't care about the
// selected context.
const contextSelectionChanged = (
  state: ComponentSelection,
  contextSelection: string
): ComponentSelection => ({
  ...state,
  treeSelection: contextSelection ? [contextSelection] : [],
  selectionStart: contextSelection,
});

const componentTreeSelectionStartSelected = (
  state: ComponentSelection,
  { selectionStart }: ComponentTreeSelectionStartSelected
): ComponentSelection => ({
  ...state,
  treeSelection: selectionStart ? [selectionStart] : [],
  selectionStart,
});

const componentGraphSelectionChanged = (
  state: ComponentSelection,
  { graphSelection }: ComponentGraphSelectionChanged
): ComponentSelection => {
  return {
    ...state,
    graphSelection,
  };
};

const componentTreeSelectionChanged = (
  state: ComponentSelection,
  { treeSelection }: ComponentTreeSelectionChanged
): ComponentSelection => ({
  ...state,
  treeSelection,
});

const selectionStartSet = (
  state: ComponentSelection,
  { selectionStart }: SelectionStartSet
): ComponentSelection => ({
  ...state,
  selectionStart,
});

const toggleTreeSelection = (
  state: ComponentSelection,
  { nodeId }: SelectionToggle
): ComponentSelection => ({
  ...state,
  treeSelection: getNewSelection(state.treeSelection, nodeId).sort(),
});

/**
 * Toggling the selection start is a no-op, so that the context component
 * cannot be deselected in the main component hierarchy.
 */
const toggleTreeSelectionKeepingSelectionStart = (
  state: ComponentSelection,
  payload: SelectionToggle
): ComponentSelection => {
  if (payload.nodeId === state.selectionStart) {
    return state;
  }
  return toggleTreeSelection(state, payload);
};

const getNewSelection = (selection: string[], nodeId: string) => {
  if (selection.includes(nodeId)) {
    return selection.filter(id => id !== nodeId);
  }
  return [...selection, nodeId];
};

const clearGraphSelection = (
  state: ComponentSelection
): ComponentSelection => ({
  ...state,
  graphSelection: [],
});

export const componentSelectionOperations = {
  componentTreeSelectionStartSelected,
  contextSelectionChanged,
  componentGraphSelectionChanged,
  componentTreeSelectionChanged,
  selectionStartSet,
  toggleTreeSelection,
  toggleTreeSelectionKeepingSelectionStart,
  clearGraphSelection,
};
